import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const authAPI = {
  googleLogin: (token) => api.post('/auth/google', { token }),
  getMe:       ()      => api.get('/auth/me'),
};

// ── Settings ──────────────────────────────────────────────────────────────────
export const settingsAPI = {
  getFeedbackGate:    ()        => api.get('/settings/feedback-status'),
  toggleFeedbackGate: ()        => api.patch('/admin/settings/feedback-toggle'),
  setFeedbackGate:    (isOpen)  => api.patch('/admin/settings/feedback-gate', { feedback_open: isOpen }),
};

// ── Departments ───────────────────────────────────────────────────────────────
export const departmentsAPI = {
  getAll: ()         => api.get('/departments'),
  create: (data)     => api.post('/admin/departments', data),
  update: (id, data) => api.put(`/admin/departments/${id}`, data),
  delete: (id)       => api.delete(`/admin/departments/${id}`),
};

// ── Feedback ──────────────────────────────────────────────────────────────────
export const feedbackAPI = {
  getStatus: ()        => api.get('/feedback/status'),
  submit:    (entries) => api.post('/feedback/submit', { entries }),
};

// ── Analytics ─────────────────────────────────────────────────────────────────
export const analyticsAPI = {
  get:          (params) => api.get('/admin/analytics', { params }),
  exportCSV:    (params) => api.get('/admin/analytics/export', { params, responseType: 'blob' }),
  getAuditLogs: (params) => api.get('/admin/audit-logs', { params }),
};

// ── Authorized Users ──────────────────────────────────────────────────────────
export const authorizedUsersAPI = {
  getAll:  (params)     => api.get('/admin/authorized-users', { params }),
  upload:  (rows, mode) => api.post('/admin/authorized-users/upload', { rows, mode }),
  update:  (id, data)   => api.patch(`/admin/authorized-users/${id}`, data),
  toggle:  (id)         => api.patch(`/admin/authorized-users/${id}/toggle`),
  delete:  (id)         => api.delete(`/admin/authorized-users/${id}`),
  export:  ()           => api.get('/admin/authorized-users/export', { responseType: 'blob' }),
};

export default api;
